// extracted by mini-css-extract-plugin
export default {"icon":"ImageFinder_icon__Hpq0Z","objectCard":"ImageFinder_objectCard__CicE4"};